import DuckEntity from './DuckEntity'

const entity = new DuckEntity('communicationPlans');
const reducer = entity.reducer;
export {reducer as default, entity};
